const OPEN_EVENT = "openMapModal";
const CLOSE_EVENT = "closeMapModal";
const canUseWindow = () => typeof window !== "undefined";
export const emitOpenMapModal = (payload = {}) => {
    if (!canUseWindow())
        return;
    window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: payload }));
};
export const emitCloseMapModal = () => {
    if (!canUseWindow())
        return;
    window.dispatchEvent(new CustomEvent(CLOSE_EVENT));
};
export const onOpenMapModal = (call) => {
    if (!canUseWindow())
        return () => { };
    const handler = (event) => {
        var _a;
        const detail = (_a = event.detail) !== null && _a !== void 0 ? _a : {};
        call(detail);
    };
    window.addEventListener(OPEN_EVENT, handler);
    return () => window.removeEventListener(OPEN_EVENT, handler);
};
export const onCloseMapModal = (call) => {
    if (!canUseWindow())
        return () => { };
    window.addEventListener(CLOSE_EVENT, call);
    return () => window.removeEventListener(CLOSE_EVENT, call);
};
